import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokenHasBold, visibleRecipeText } from './recipeTextFormat';
import { DiffOp, diffTokens } from './wordDiff';

const DELETE_SX = {
  color: '#b42318',
  textDecoration: 'line-through',
  textDecorationThickness: '2px',
  textDecorationColor: '#b42318',
  backgroundColor: 'rgba(180,35,24,0.08)',
  borderRadius: '3px',
  px: '1px',
};

const INSERT_SX = {
  color: '#157347',
  fontWeight: 700,
  backgroundColor: 'rgba(21,115,71,0.10)',
  borderRadius: '3px',
  px: '1px',
};

const wrapSx = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  lineHeight: 1.7,
  fontSize: '0.95rem',
  color: '#1c2b3a',
};

function EmptyMark() {
  return (
    <Typography component="span" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>—</Typography>
  );
}

function DiffToken({
  value,
  source,
  sx,
}: {
  value: string;
  source: string;
  sx?: object;
}) {
  return (
    <Box component="span" sx={{ ...sx, fontWeight: tokenHasBold(source, value) ? 700 : undefined }}>
      {value}
    </Box>
  );
}

export function OriginalDiffText({ original, proposed }: { original: string; proposed: string }) {
  if (!visibleRecipeText(original).trim()) return <EmptyMark />;
  const ops = diffTokens(visibleRecipeText(original), visibleRecipeText(proposed));
  return (
    <Box component="span" sx={wrapSx}>
      {ops.map((op: DiffOp, index) => {
        if (op.type === 'insert') return null;
        if (op.type === 'delete') {
          return <DiffToken key={index} value={op.value} source={original} sx={DELETE_SX} />;
        }
        return <DiffToken key={index} value={op.value} source={original} />;
      })}
    </Box>
  );
}

export function ProposedDiffText({ original, proposed }: { original: string; proposed: string }) {
  if (!visibleRecipeText(proposed).trim()) return <EmptyMark />;
  const ops = diffTokens(visibleRecipeText(original), visibleRecipeText(proposed));
  return (
    <Box component="span" sx={wrapSx}>
      {ops.map((op: DiffOp, index) => {
        if (op.type === 'delete') return null;
        if (op.type === 'insert') {
          return <DiffToken key={index} value={op.value} source={proposed} sx={INSERT_SX} />;
        }
        return <DiffToken key={index} value={op.value} source={proposed} />;
      })}
    </Box>
  );
}
